function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 24H0V0H24V24ZM19.97 18.351V18.082L18.723 16.858C18.613 16.774 18.558 16.636 18.581 16.499V7.501C18.558 7.364 18.613 7.226 18.723 7.142L20 5.918V5.649H15.578L12.426 13.512L8.84 5.649H4.202V5.918L5.696 7.717C5.842 7.85 5.917 8.044 5.897 8.24V15.312C5.941 15.567 5.86 15.828 5.681 16.014L4 18.052V18.321H8.766V18.052L7.085 16.014C6.904 15.828 6.819 15.569 6.853 15.312V9.196L11.036 18.321H11.522L15.115 9.196V16.469C15.115 16.663 15.115 16.701 14.988 16.828L13.696 18.082V18.351H19.97Z",
  fill: "#E5E7EB"
});

function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.f274b6b859a2d1dbe3a7182965660314.svg";
export { ForwardRef as ReactComponent };